import PartialRepayDialog from './PartialRepayDialog.vue';

export default PartialRepayDialog;
